import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $id: String!
    $data: PortionUpdateInput!
  ) {
    updateOnePortion(
      where: { id: $id }
      data: $data
    ) {
      name
    }
  }
`

export default () => (
  useMutation(MUTATION, `Parcela actualizada`, mutationTypes.UPDATE)
)
